import { render, staticRenderFns } from "./CoCardPlanHistory.vue?vue&type=template&id=6b2b7118&scoped=true&"
import script from "./CoCardPlanHistory.vue?vue&type=script&lang=ts&"
export * from "./CoCardPlanHistory.vue?vue&type=script&lang=ts&"
import style0 from "./CoCardPlanHistory.vue?vue&type=style&index=0&id=6b2b7118&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2b7118",
  null
  
)

export default component.exports